<mat-list class="compact-file-list" tabindex="0" (focus)="onListFocus()" (blur)="onListBlur()">
  @if (files && files.length > 0) {
    @for (file of files; track file.name; let i = $index) {
      <mat-list-item
        class="file-item"
        [class.selected]="selectedFile === file"
        [class.focused]="hasFocus && focusedIndex === i"
        (click)="onFileClick(file)"
      >
        <div class="file-item-content">
          <div class="file-icon">
            <app-filetype-icon [value]="file.fileExtension"></app-filetype-icon>
          </div>
          <div class="file-info">
            <p class="file-name">{{ file.name }}</p>
            <p class="file-date">{{ file.dateModified | date: 'MMM d, y, h:mm:ss a' }}</p>
          </div>
          <div class="file-actions">
            <span class="icon-button">
              <mat-icon class="material-symbols-outlined" matTooltip="Preview file" matTooltipShowDelay="500" (click)="onPreviewClick(file)"
                >document_search</mat-icon
              >
            </span>
          </div>
        </div>
      </mat-list-item>
    }
  }
</mat-list>
